import React, { useEffect, useState } from 'react';
import './ReminderNotification.css';

function ReminderNotification({ reminders }) {
  const [visibleReminders, setVisibleReminders] = useState([]);

  useEffect(() => {
    if (!reminders || reminders.length === 0) return;

    // Check for reminders due within next 5 minutes
    const now = Math.floor(Date.now() / 1000);
    const upcomingReminders = reminders.filter(reminder => {
      const reminderTime = reminder.time;
      return reminderTime && reminderTime > now && reminderTime <= now + 300; // Within 5 minutes
    });

    // Show notifications for new upcoming reminders
    upcomingReminders.forEach(reminder => {
      // Check if we've already shown this reminder
      const alreadyShown = visibleReminders.some(r => r.id === reminder.id);
      if (!alreadyShown) {
        // Add to visible reminders
        setVisibleReminders(prev => [...prev, {
          ...reminder,
          id: reminder.id || reminder.time,
          shownAt: Date.now()
        }]);

        // Show browser notification if permission granted
        if ('Notification' in window && Notification.permission === 'granted') {
          new Notification('⏰ Slack Reminder', {
            body: reminder.text,
            icon: '/slack-icon.png',
            tag: `reminder-${reminder.id}`
          });
        }
      }
    });

    // Remove reminders that are now in the past
    setVisibleReminders(prev =>
      prev.filter(r => r.time > now)
    );
  }, [reminders]);

  const formatTimeRemaining = (timestamp) => {
    const now = Math.floor(Date.now() / 1000);
    const diff = timestamp - now;

    if (diff < 60) {
      return 'in less than a minute';
    } else if (diff < 3600) {
      const minutes = Math.floor(diff / 60);
      return `in ${minutes} ${minutes === 1 ? 'minute' : 'minutes'}`;
    } else {
      const hours = Math.floor(diff / 3600);
      return `in ${hours} ${hours === 1 ? 'hour' : 'hours'}`;
    }
  };

  const dismissReminder = (reminderId) => {
    setVisibleReminders(prev => prev.filter(r => r.id !== reminderId));
  };

  const requestNotificationPermission = async () => {
    if ('Notification' in window && Notification.permission === 'default') {
      await Notification.requestPermission();
    }
  };

  useEffect(() => {
    // Request notification permission on mount
    requestNotificationPermission();
  }, []);

  if (visibleReminders.length === 0) return null;

  return (
    <div className="reminder-notification-container">
      {visibleReminders.map(reminder => (
        <div key={reminder.id} className="reminder-notification">
          <div className="reminder-icon">⏰</div>
          <div className="reminder-content">
            <div className="reminder-title">Upcoming Reminder</div>
            <div className="reminder-text">{reminder.text}</div>
            <div className="reminder-time">{formatTimeRemaining(reminder.time)}</div>
          </div>
          <button
            className="reminder-dismiss"
            onClick={() => dismissReminder(reminder.id)}
            aria-label="Dismiss"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
}

export default ReminderNotification;
